import { Node } from '../../models/models';

export const canAddAttachment = (node: Node) => {
    return (
        (node.role === 'manager' || node.role === 'operator') &&
        node.status.key !== 'in_review'
    );
};

export const canApproveAttachment = (node: Node) => {
    return node.role === 'manager';
};

export const canRejectAttachment = (node: Node) => {
    return node.role === 'manager' || node.role === 'operator';
};

export const canReplaceAttachment = (node: Node) => {
    return node.role === 'manager' || node.role === 'operator';
};

export const isViewer = (node: Node) => {
    return node.role === 'viewer';
};

export const canPutNodeInReview = (node: Node) => {
    if (
        (node.role === 'operator' || node.role === 'manager') &&
        node.status.key === 'active'
    ) {
        return true;
    } else {
        return false;
    }
};

export const canPutNodeInDoneOrActive = (node: Node) => {
    if (node.role === 'manager' && node.status.key === 'in_review') {
        return true;
    } else {
        return false;
    }
};
